import { render, staticRenderFns } from "./ProductsLiabilityTurnoverFact.vue?vue&type=template&id=40a72e2a"
import script from "./ProductsLiabilityTurnoverFact.vue?vue&type=script&lang=js"
export * from "./ProductsLiabilityTurnoverFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports